<div class="wrapper fadeInDown">
  <div id="formContent">
    <!-- Tabs Titles -->
    <h2 class="active">Please Sign In</h2>

    <!-- Login Form -->
    <form ngNativeValidate #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">

      <input type="text"
             ngModel
             required
             id="login"
             class="fadeIn second"
             name="login"
             placeholder="login"
             oninvalid="this.setCustomValidity('Username is required')"
             oninput="this.setCustomValidity('')">

      <input type="password"
             ngModel
             required
             id="password"
             class="fadeIn third"
             name="password"
             placeholder="password"
             oninvalid="this.setCustomValidity('Password is required')"
             oninput="this.setCustomValidity('')">
      <br/>
      <label for="adminLogin" class="active">
        <input type="checkbox"
               ngModel
               id="adminLogin"
               class="fadeIn third"
               value="yes"
               name="adminLogin"/>
        Admin Login
      </label>
      <br/>

      <input type="submit" class="fadeIn fourth" value="Log In" prevent-double-submit>
    </form>
  </div>
</div>
